import {
    ChangeDetectionStrategy,
    Component,
    Input,
    output,
} from '@angular/core';
import { IAttachment } from '@interacta/util-post';

@Component({
    selector: 'interacta-ai-message-attachment-chip',
    templateUrl: './ai-message-attachment-chip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AIMessageAttachmentChipComponent {
    @Input({ required: true }) attachment!: IAttachment;
    @Input() messagesCount = 0;
    @Input() showThreadButton = true;
    @Input() hasErrors = false;

    attachmentClicked = output();
    goToThread = output();
}
